import BackIcon from '@cp/src/assets/images/icons/BackIcon';
import cx from 'classnames';
import styles from './viewProducts.module.scss';
import { useNavigate } from 'react-router-dom';
import AgTable from '@navi/web-ui/lib/components/AgTable/AgTable';
import VIEW_PRODUCTS_COL_DEFS from './ColumnDefs';
import { noop } from '@navi/web-ui/lib/utils/common';
import Pagination from '@navi/web-ui/lib/components/Pagination/Pagination';
import { DropDownPosition } from '@navi/web-ui/lib/components/Pagination/constant';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import PlusIcon from '@cp/src/assets/icons/PlusIcon';
import CreateProductDrawer from './createProductDrawer';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { getProductsByTenant } from '../../paramountActions';
import useGetTenant from '@cp/pages/Paramount/hooks/useGetTenant';
const ViewProducts = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showCreateProduct, setShowCreateProduct] = useState(false);
  const handleCreateProduct = () => {
    setShowCreateProduct(true);
  };
  const products = useSelector((state: RootState) => state.paramountSlice?.products);
  const columnData = VIEW_PRODUCTS_COL_DEFS();
  const tenant = useGetTenant();
  useEffect(() => {
    dispatch(getProductsByTenant(tenant));
  }, []);

  return (
    <div className={styles.productsPage}>
      <div className={styles.topNavContainer}>
        <div className={cx('cursor-pointer')} onClick={() => navigate(-1)}>
          <BackIcon size={'16'} />
        </div>
      </div>
      <div className="flex flex-row justify-between p-[20px]">
        <Typography variant="h2">Create Product</Typography>
        <Button
          variant="primary"
          size="medium"
          startAdornment={<PlusIcon fillColor="white" />}
          onClick={handleCreateProduct}
        >
          Create Product
          <CreateProductDrawer
            showCreateProduct={showCreateProduct}
            setShowCreateProduct={setShowCreateProduct}
          />
        </Button>
      </div>
      <AgTable
        className={styles.productsTable}
        columnDefs={columnData}
        rowData={products}
        onGridReady={noop}
        defaultColDef={{
          suppressMovable: true,
          wrapText: true
        }}
        style={{
          height: 575,
          width: '97%'
        }}
        sizeColumnsToFit={true}
        theme={'alpine'}
        alternateRowColor="var(--greyscale-content-5)"
        paginationWrapperClasses={'paginationWrapperClasses'}
        PaginationComponent={
          <Pagination
            pageSize={0}
            currentPage={0}
            totalCount={20}
            onPageChange={noop}
            onPageSizeChange={noop}
            pageNumberDropDownPosition={DropDownPosition.TOP}
          />
        }
      />
    </div>
  );
};

export default ViewProducts;
